module.exports = __webpack_public_path__ + "img/kusa04.2f208fa6.png";